import type { WhatsappSelectorsType } from "@whatslly/types/integrations/im/WhatsappGetSelectorsResponse";
import type { IStorage } from "@whatslly/commons/storage.constants";
import { InjectStorage, STORAGE } from "@whatslly/commons/storage.constants";
import { inject, injectable } from "inversify";

@injectable()
export class BlockProfileImageService {
  constructor(@inject(InjectStorage) private readonly storage: IStorage) {}
  async init(selectors: WhatsappSelectorsType) {
    const userObj = await this.storage.get(STORAGE.USER);
    if (!userObj?.blockChangeProfileImage) {
      return;
    }

    document.addEventListener(
      "click",
      (event) => {
        const el = document.querySelector(selectors.css.profilePicSelector);
        if (el?.contains(event.target as HTMLElement)) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  }
}
